<template>
    <div class="control-shape-viever leaflet-control leaflet-bar">
        <a class="fa fa-file-o" title="Ручной ввод координат" @click.stop="addCoordinates" v-if="!editing"></a>
        <a class="fa fa-map-marker" title="Создать маркер" @click.stop="newMarker" v-if="!editing"></a>
        <a class="fa fa-object-group" title="Создать полигон" @click.stop="newPolygon" v-if="!editing"></a>
        <a class="fa fa-object-ungroup" title="Добавить полигон" @click.stop="addPolygon" v-if="editing"></a>
        <a class="fa fa-hand-pointer-o" title="Разрешить перетаскивание" @click.stop="toggleDragging" v-if="editing" v-bind:class="{ active: dragging }"></a>
        <a class="fa fa-trash" title="Очистить" @click.stop="deleteShape" v-if="editing"></a>
        <shape-file-uploader @failed="exportError" @complete="showGeojson" @loading="loading"></shape-file-uploader>
        <a class="fa fa-arrow-down" title="Экспортировать в Shapefile (ZIP)" @click.stop="() => exportShape('shape-zip')"></a>
        <a class="fa fa-arrow-down" title="Экспортировать в KML" @click.stop="() => exportShape('kml')"></a>
        <a class="fa fa-floppy-o active" title="Сохранить" @click.stop="save" v-if="hasChanges"></a>
    </div>
</template>

<script>
    import ShapeFileUploader from './ShapeFileUploader.vue'
    import Vue from 'vue'
    import _ from 'lodash'
    import '../lib/Leaflet-WFST'

    export default Vue.extend({
        data() {
            return {
                editing: false,
                dragging: false,
                hasChanges: false
            }
        },

        mounted() {
            this.vm.map.disableOnClick = true;
            this.editTools = this.vm.map.editTools;

            window.bus.$on('map:system:updatecoordinates', this.updateCoordinates);

            // Слой для нарисованных геометрий
            let type = this.options.layer.split(':');
            this.vm.loading = true;

            this.wfst = new L.WFST({
                url: this.service,
                typeNS: type[0],
                typeName: type[1],
                crs: L.CRS.EPSG4326,
                filter: new L.Filter.EQ().append(this.options.param, this.options.id),
                style: this.shapeStyle
            }).once('load', () => {
                this.wfst.addTo(this.vm.map);
                this.wfst.eachLayer(layer => {
                    if (!(layer instanceof L.Marker)) layer.showMeasurements();
                });

                this.vm.fitLayer = this.wfst;
                this.vm.loading = false;

                setTimeout(() => this.vm.focus(), 200);
            });

            this.wfst.on('changed', () => this.hasChanges = true);

            this.wfst.on('save:success', () => {
                let polygon = this.editTools.currentPolygon;

                if (polygon) {
                    polygon.disableEdit();
                }

                this.hasChanges = false;
                this.vm.loading = false;

                window.bus.$emit("map:system:redraw");
                window.bus.$emit('map:system:notification', 'Изменения сохранены на сервере ГИС');
            });

            this.wfst.on('save:failed', (error) => {
                this.vm.loading = false;
                window.bus.$emit('map:system:error', `При сохранении изменений произошла ошибка.
Cервер не может обработать запрос из-за ошибок в геометрии или внутренней проблемы.
Возможно, сохраняемый объект выходит за пределы географической сетки,
содержит самопересечений или полигоны из менее, чем трех точек`);
            });

            this.wfst.on('error', (error) => {
                this.vm.loading = false;
                window.bus.$emit('map:system:error', 'При обращении к серверу ГИС произошла ошибка. Возможно, сервер отключен, недоступен или не может обработать запрос');
            });

            // Обновление состояние редактирования
            this.editTools.on('editable:enabled', () => this.editing = true);

            this.editTools.on('editable:enable', e => {
                if (this.editTools.currentPolygon) this.editTools.currentPolygon.disableEdit();

                let polygon = this.editTools.currentPolygon = e.layer;
                this.vm.fitLayer = polygon;

                if (polygon.dragging) {
                    if (polygon instanceof L.Marker) {
                        polygon.dragging.enable();
                        this.dragging = true;
                    }
                    else {
                        polygon.dragging.disable();
                    }
                }

                polygon.on('click', function (click) {
                    if (this.editEnabled()) {
                        if (click.originalEvent.ctrlKey) {
                            this.editor.newHole(click.latlng);
                        }
                    }
                });

                if (polygon.showMeasurements) {
                    polygon.on('drag', drag => drag.target.hideMeasurements());
                    polygon.on('dragend', drag => drag.target.showMeasurements().updateMeasurements);
                }

                if (polygon.getLatLng) {
                    polygon.on('drag', drag => this.vm.coordinates = [drag.target.getLatLng()]);
                }

                let latlngs = polygon.getLatLngs ? polygon.getLatLngs() : [polygon.getLatLng()];

                this.vm.coordinates = latlngs;
                this.editTools.fire('editable:enabled');
                window.bus.$emit('map:system:error');
                window.bus.$emit('map:system:notification');
            });

            this.editTools.on('editable:disable', () => {
                this.dragging = this.editing = false;

                this.vm.coordinates = [];
                this.editTools.currentPolygon.off('click');
                this.editTools.currentPolygon.off('drag');
                this.editTools.currentPolygon.off('dragend');
                delete this.editTools.currentPolygon;

                window.bus.$emit('map:system:error');
                window.bus.$emit('map:system:notification');

                this.vm.fitLayer = this.wfst;
            });

            this.editTools.on('editable:shape:deleted', e => {
                if (_.get(e.layer, 'feature.id')) {
                    this.wfst.removeLayer(e.layer);
                }
            }),

            // Обновление разметки размеров при перемещении точек
            this.vm.map.on('editable:editing', e => {
                if (_.isEmpty(_.get(e.layer, 'feature.properties'))) {
                    this.addEditLayer(e.layer);
                }

                this.wfst.editLayer(e.layer);

                if (e.layer.showMeasurements) {
                    e.layer.showMeasurements().updateMeasurements();
                }

                window.bus.$emit('map:system:error');
                window.bus.$emit('map:system:notification');
            });

            // Обновлении списка координат при завершении рисования
            this.vm.map.on('editable:drawing:end', e => {
                if (e.layer.getLatLng) {
                    this.vm.coordinates = [e.layer.getLatLng()];
                }
            });

            // Переход в режим редактирования по двойному клику
            this.vm.map.on('layeradd', function (e) {
                if (e.layer.toggleEdit) e.layer.on('dblclick', L.DomEvent.stop).on('dblclick', e.layer.toggleEdit);
            });

            this.vm.map.on('layerremove', function (e) {
                if (e.layer.toggleEdit) e.layer.off('dblclick', L.DomEvent.stop).off('dblclick', e.layer.toggleEdit);
            });
        },

        methods: {
            exportShape(format) {
                this.wfst.exportShape(format);
            },

            updateCoordinates(coordinates) {
                let layer = this.editTools.currentPolygon;

                if (layer) {
                    if (layer.setLatLngs) {
                        layer.setLatLngs(coordinates);
                    } else {
                        layer.setLatLng(coordinates[0]);
                    }

                    this.wfst.editLayer(layer);

                    window.bus.$emit('map:system:notification', `Координаты редактируемого объекта изменены.
Нажмите "Сохранить" в панели инструментов карты для отправки изменений на сервер`);
                }
                else {
                    layer = (coordinates.length == 1) ? L.marker(coordinates[0]) : L.polygon([coordinates]).setStyle(this.shapeStyle);
                    layer.feature = {
                        properties: {}
                    };

                    this.addEditLayer(layer);
                    this.vm.focus();
                    window.bus.$emit('map:system:notification', `Из введенных координат создан новый  ${coordinates.length == 1 ? 'маркер' : 'полигон'}.
Нажмите "Сохранить" в панели инструментов карты для отправки изменений на сервер`);
                }

                layer.disableEdit();
                layer.enableEdit(this.map);
            },

            addEditLayer(layer) {
                this.wfst.addLayer(layer);

                let properties = _.set({}, this.options.param, this.options.id);
                _.merge(properties, this.options.properties);
                layer.setProperties(properties);
            },

            addCoordinates() {
                this.vm.coordinates = [L.latLng(0, 0)];
                this.vm.coordinatesVisible = true;
            },

            addPolygon() {
                let polygon = this.editTools.currentPolygon;

                if (polygon) {
                    polygon.enableEdit();
                    polygon.editor.newShape();
                }
            },

            newMarker() {
                let marker = this.editTools.startMarker();
                this.addEditLayer(marker);
                this.dragging = true;
            },

            newPolygon() {
                let polygon = this.editTools.startPolygon().setStyle(this.shapeStyle);
                this.wfst.addLayer(polygon);
                polygon.dragging.disable();
            },

            deleteShape() {
                let polygon = this.editTools.currentPolygon;

                if (polygon) {
                    if (polygon.editor && polygon.editor.deleteShape) {
                        polygon.editor.deleteShape(polygon);
                    }

                    polygon.remove();
                    this.wfst.removeLayer(polygon);
                }
            },

            save() {
                window.bus.$emit('map:system:error');
                window.bus.$emit('map:system:notification');

                _(this.wfst.getLayers())
                    .filter(layer => layer.getLatLngs && _.flattenDeep(layer.getLatLngs()).length == 0)
                    .forEach(layer => this.wfst.removeLayer(layer));

                this.vm.loading = true;
                this.wfst.save();
            },

            toggleDragging() {
                let polygon = this.editTools.currentPolygon;

                if (polygon) {
                    if (polygon.dragging.enabled()) {
                        polygon.dragging.disable();
                    }
                    else {
                        polygon.dragging.enable();
                    }
                }

                this.dragging = polygon && polygon.dragging.enabled();
            },

            loading() {
                this.vm.loading = true;
            },

            exportError(error) {
                this.vm.loading = false;
                window.bus.$emit('map:system:notification');
                window.bus.$emit('map:system:error', error.error || 'При загрузке файла произошла ошибка. Возможно, сервер недоступен или не может обработать запрос');
            },

            showGeojson(geojson, name) {
                this.vm.loading = false;
                let features = _.map(geojson.geometries, feature => L.geoJson(feature, {style: this.shapeStyle}));
                _.each(features, layers => layers.eachLayer(this.addEditLayer));

                this.vm.map.fitBounds(this.wfst.getBounds());

                window.bus.$emit('map:system:error');
                window.bus.$emit('map:system:notification', 'Выбранный файл загружен на карту');
            }
        },

        components: { ShapeFileUploader }
    });
</script>

<style scoped>
    a {
        cursor: pointer;
    }

    .active {
        color: #fff;
        background: #555;
    }

    .active:hover {
        color: #fff;
        background: #888;
    }
</style>


// WEBPACK FOOTER //
// WFSTEditor.vue?e80f7762